import React from 'react';
import PropTypes from 'prop-types';
import { HashRouter, Route } from 'react-router-dom';
import Routes from './Routes';

const Root = props => {
	return (
		<HashRouter>
			<Route path="*" component={Routes} />
		</HashRouter>
	);
};

Root.propTypes = {
	data: PropTypes.object,
};

export default Root;



// WEBPACK FOOTER //
// ./src/root/index.js